module.exports = __webpack_public_path__ + "static/media/linkedin.0183c031.svg";